<template>
  <section class="content-section">
    <div class="container">
      <div class="content">
        <div
          class="content-block"
          v-html="event.content"
        ></div>

        <div class="host-section">
          <h4>Hosted by</h4>
          <div
            v-if="event.speaker !== null"
            class="host"
          >
            <img
              v-if="speakerImage"
              class="host-image"
              :src="speakerImage"
              alt="host"
            />
            <div class="host-info">
              <span class="host-name">{{ event.speaker?.name }}</span>
              <span class="host-role">{{ event.speaker?.title }}</span>
            </div>
          </div>
          <p class="host-description">{{ event.speaker?.biography }}</p>
        </div>
      </div>
      <div class="even-form-wrapper">
        <AlreadyRegistered
          v-if="upcomingJoined"
          :event-link="event.event_link"
        />
        <JoinEvent
          v-if="upcomingEvent && !alreadyJoinedEvent"
          :event-id="event.id"
          :event-private="event.private"
          @email-joined="setAlreadyJoinedEvent()"
        />
        <WatchEvent
          v-if="pastEvent"
          :event-link="event.event_link"
          :event-id="event.id"
          :event-private="event.private"
          @email-joined="setAlreadyJoinedEvent()"
        />

        <Social page-name="event" />
      </div>
    </div>
  </section>
</template>

<script>
import JoinEvent from '../JoinEvent/JoinEvent.vue';
import AlreadyRegistered from '../AlreadyRegistered/AlreadyRegistered.vue';
import WatchEvent from '../WatchEvent/WatchEvent.vue';
import Social from '~/components/Common/Social/Social.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';

export default {
  components: {
    JoinEvent,
    AlreadyRegistered,
    WatchEvent,
    Social,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      alreadyJoinedEvent: false,
    };
  },
  computed: {
    pastEvent() {
      return this.event.upcoming_or_past === 'past';
    },
    upcomingEvent() {
      return this.event.upcoming_or_past === 'upcoming';
    },
    upcomingJoined() {
      return this.upcomingEvent && this.alreadyJoinedEvent;
    },
    speakerImage() {
      return this.event.speaker?.image
        ? cloudinaryImage({ imagePath: this.event.speaker.image, width: 100 })
        : null;
    },
  },
  async mounted() {
    if (this.$localStorage?.getItem('events_email') !== null) {
      try {
        this.alreadyJoinedEvent = await this.$cmsApi.get(
          `/events/${this.event.id}/email-joined`,
          {
            email: this.$localStorage.getItem('events_email'),
          }
        );
      } catch (error) {
        console.error(error);
      }
    }
  },
  methods: {
    setAlreadyJoinedEvent() {
      this.alreadyJoinedEvent = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ContentSection.scss';
</style>
